import React, { forwardRef } from "react";
import {
  Kbd as ShadcnKbd,
  KbdGroup as ShadcnKbdGroup,
} from "src/shadcn/components/kbd";

const Kbd = forwardRef<HTMLElement, React.ComponentProps<typeof ShadcnKbd>>(
  (props, ref) => <ShadcnKbd ref={ref} {...props} />
);
Kbd.displayName = "Kbd";

const KbdGroup = forwardRef<
  HTMLElement,
  React.ComponentProps<typeof ShadcnKbdGroup>
>((props, ref) => <ShadcnKbdGroup ref={ref} {...props} />);
KbdGroup.displayName = "KbdGroup";

export { Kbd, KbdGroup };
